import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import Layout from "../../components/Wrappers/Layout";
import { FormControl } from "@mui/material";
import { Card, Alert } from "reactstrap";
import { Row, Col } from "reactstrap";
import Box from "@mui/material/Box";
import { AiOutlineSearch } from "react-icons/ai";
import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";
import BackButton from "../../components/BackButton/BackButton";

const GetRegenerateInVoice = () => {
	const navigate = useHistory();
	const clickHereToGoInvoice = () => {
		navigate.push({
			pathname: `/index/merchantInvoice`
			//   search: `?userId=${id}`,
		});
	};

	return (
		<>
			<Layout>
				<BackButton />
				<div
					style={{
						background: "white",
						paddingTop: "1rem",
						borderRadius: "5px"
					}}
				>
					<Box marginLeft={3} marginRight={3} paddingBottom={2}>
						<Row>
							<Col md={12}>
								<Row className="detail-info row">
									<Col
										md={6}
										style={{
											fontSize: "15px"
										}}
									>
										Invoice No
									</Col>
									<Col md={6}> 9183 </Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col
										md={6}
										style={{
											fontSize: "15px"
										}}
									>
										Date
									</Col>
									<Col md={6}>2022-07-05</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col
										md={6}
										style={{
											fontSize: "15px"
										}}
									>
										Invoice Sent To
									</Col>
									<Col md={6}> amey.dalvi@paymentz.com</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col
										md={6}
										style={{
											fontSize: "15px"
										}}
									>
										Customer Name
									</Col>
									<Col md={6}>Amey</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col
										md={6}
										style={{
											fontSize: "15px"
										}}
									>
										Customer Phone No
									</Col>
									<Col md={6}>091-8149389795</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col
										md={6}
										style={{
											fontSize: "15px"
										}}
									>
										Order ID
									</Col>
									<Col md={6}>AB_1189810338</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col
										md={6}
										style={{
											fontSize: "15px"
										}}
									>
										Order Description
									</Col>
									<Col md={6}>Duplicate order for AB_1189810337</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col
										md={6}
										style={{
											fontSize: "15px"
										}}
									>
										Order Amount
									</Col>
									<Col md={6}>12.00 GBP</Col>
								</Row>
							</Col>
						</Row>
					</Box>
					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1.5rem",
							marginBottom: "15px"
						}}
					>
						<Grid item md={4}></Grid>
						<Grid item md={4}>
							{/* <Button
                style={{
                  marginLeft: "0.7rem",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                onClick={clickHereToGoInvoice}
              >
                Click Here to Go To Invoice
              </Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={clickHereToGoInvoice}
							>
								Click Here to Go To Invoice
							</CustomButton>
						</Grid>
						<Grid item md={4}></Grid>
					</Grid>
				</div>
			</Layout>
			{/* <Layout>
        <Card>
          <Grid
            container
            style={{
              padding: "10px",
              marginTop: "1rem",
              marginBottom: "8px",
            }}
          >
            <Grid item md={4}></Grid>
            <Grid item md={4}>
              Invoice No : 9183
            </Grid>
            <Grid item md={4}></Grid>
          </Grid>
          <Grid
            container
            style={{
              padding: "10px",
              marginBottom: "8px",
            }}
          >
            <Grid item md={4}></Grid>
            <Grid item md={4}></Grid>
            <Grid item md={4}>
              Date. : 2022-07-05
            </Grid>
          </Grid>
          <Box marginLeft={3} marginRight={3} paddingBottom={2}>
            <Row>
              <Col md={12}>
                <Row className="detail-info row">
                  <Col md={6}>Invoice Sent To</Col>
                  <Col md={6}>amey.dalvi@paymentz.com</Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}> Customer Name</Col>
                  <Col md={6}> Amey</Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}> Customer Phone No</Col>
                  <Col md={6}> 091-8149389795</Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}> Order ID</Col>
                  <Col md={6}>AB_1189810338</Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Order Description</Col>
                  <Col md={6}> Duplicate order for AB_1189810337</Col>
                </Row>
                <hr />
                <Row className="detail-info row">
                  <Col md={6}>Order Amount</Col>
                  <Col md={6}>12.00 GBP</Col>
                </Row>
              </Col>
            </Row>
          </Box>
          <Grid
            container
            style={{
              padding: "10px",
              marginTop: "1.5rem",
              marginBottom: "15px",
            }}
          >
            <Grid item md={4}></Grid>
            <Grid item md={4}>
              <Button
                style={{
                  marginLeft: "0.7rem",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                endIcon={<AiOutlineSearch />}
                variant="contained"
                // onClick={getRegenerateInvoice}
              >
                Click Here to Go To Invoice
              </Button>
            </Grid>
            <Grid item md={4}></Grid>
          </Grid>
        </Card>
      </Layout> */}
		</>
	);
};

export default GetRegenerateInVoice;
